import React, { useState, useEffect } from "react"
import CustomToast from "../../components/CustomToast.js"
import CustomTable from "../../components/CustomTable/CustomTable.js"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import InputGroup from "react-bootstrap/InputGroup"
import DatePicker from "react-datepicker"
import { searchStores } from "../../utils/api/store"
import moment from "moment"
import CustomMap from "../../components/CustomMap/CustomMap"
import { shortenUrl } from "../../utils/api/urlShortener"
import { Col, Row } from "react-bootstrap"

function Login({ setInactive }) {
  const [details, setMessage] = useState({ message: "", type: "" })
  const [showToast, setShowToast] = useState(false)
  const [data, setData] = useState([])
  const [mapUrls, setMapUrls] = useState([])
  const [searchData, setSearchData] = useState({
    encodedBy: "",
    dateTo: new Date(),
    dateFrom: new Date(),
  })
  const [show, setShow] = useState(false)
  const [exportable, setExportable] = useState({ items: [], headers: [] })
  const [backdrop, setBackdrop] = useState(true)
  const [mapData, setMapData] = useState({
    lat: 0,
    lng: 0,
    address: "",
    store_name: "",
    photo: "",
  })
  const [signatureURL, setSignatureURL] = useState("")
  const [showSignature, setShowSignature] = useState(false)

  const headers = [
    "Date Time",
    "Store Name",
    "Address 1",
    "Address 2",
    "Long/Lat 1",
    "Long/Lat 2",
    "Street",
    "Barangay",
    "City",
    "Photo",
    "Binibisita ng Ahente",
    "Poster Priority 1 (Palantandaan)",
    "Poster Priority 2 (Babala)",
    "Flyer",
    "Trade Letter",
    "Nakadisplay ba ang illicit cigarette sa tindahan",
    "Cigarette Sale Details",
    "Liked Fight It QR Code?",
    "Encoded By",
    "Mobile Number",
  ]

  const handleShow = (long, lat, address, store_name, photo) => {
    setMapData({
      lat: lat,
      lng: long,
      address: address,
      store_name: store_name,
      photo: photo,
    })
    setInactive(false)
    setShow(true)
  }

  const handleShowSignature = (url) => {
    setSignatureURL(url)
    setShowSignature(true)
  }

  const handleSearch = async () => {
    setMapUrls([])
    const response = await searchStores(
      searchData.dateFrom,
      searchData.dateTo,
      searchData.encodedBy
    )

    if (response?.data) {
      console.log(response)
      let dataResponse = response.data.data
      let dataToDisplay = []
      let exportableData = []
      // Loop through the data and push it to the dataToDisplay array
      let extractedMapUrls = []
      dataResponse.forEach((item) => {
        // get the data in each object
        let _data = []
        let exportableTemp = []

        // convert to proper date
        let date = item.added_on
          ? moment(item.added_on).format("MMMM DD, YYYY, h:mm:ss a")
          : ""
        _data.push(date)
        exportableTemp.push(date)

        let store_name = item.store_name ? item.store_name.toString() : ""
        _data.push(store_name)
        exportableTemp.push(store_name)

        let address1 = item.address1 ? item.address1.toString() : ""
        _data.push(address1)
        exportableTemp.push(item.address1 ? item.address1.toString() : "")

        let address2 = item.address2 ? item.address2.toString() : ""
        _data.push(address2)
        exportableTemp.push(address2)

        let long1 = item.longitude1 ? item.longitude1.toString() : ""
        let lat1 = item.latitude1 ? item.latitude1.toString() : ""
        let long1lat1 = long1 ? long1 + ", " + lat1 : ""
        _data.push(long1lat1)
        exportableTemp.push(long1lat1)

        let long2 = item.longitude2 ? item.longitude2.toString() : ""
        let lat2 = item.latitude2 ? item.latitude2.toString() : ""
        let long2lat2 = long2 ? long2 + ", " + lat2 : ""
        _data.push(long2lat2)
        exportableTemp.push(long2lat2)

        let street = item.street_name ? item.street_name.toString() : ""
        _data.push(street)
        exportableTemp.push(street)

        let barangay = item.barangay ? item.barangay.toString() : ""
        _data.push(barangay)
        exportableTemp.push(barangay)

        let city = item.city ? item.city.toString() : ""
        _data.push(city)
        exportableTemp.push(city)

        let photo = item.photo ? item.photo.toString() : null
        // current domain plus the path to the image
        let mapUrl =
          window.location.origin +
          "/public_map?lat=" +
          lat1 +
          "&lng=" +
          long1 +
          "&address=" +
          address1 +
          "&store_name=" +
          store_name +
          "&photo=" +
          photo

        extractedMapUrls.push(mapUrl)
        if (photo) {
          _data.push(
            <button
              onClick={() =>
                handleShow(long1, lat1, address1, store_name, photo)
              }
            >
              View
            </button>
          )
          exportableTemp.push(mapUrl)
        } else {
          let reason_image = item.reason_image
            ? item.reason_image.toString()
            : ""
          _data.push(reason_image)
          exportableTemp.push(reason_image)
        }

        _data.push(item.agent_visit ? item.agent_visit.toString() : "")
        exportableTemp.push(item.agent_visit ? item.agent_visit.toString() : "")

        let poster_priority_1 = item.poster_priority_1
          ? item.poster_priority_1.toString()
          : null

        if (poster_priority_1) {
          _data.push(poster_priority_1)
          exportableTemp.push(poster_priority_1)
        } else {
          _data.push("YES")
          exportableTemp.push("YES")
        }

        let poster_priority_2 = item.poster_priority_2
          ? item.poster_priority_2.toString()
          : null

        if (poster_priority_2) {
          _data.push(poster_priority_2)
          exportableTemp.push(poster_priority_2)
        } else {
          _data.push("YES")
          exportableTemp.push("YES")
        }

        let flyer = item.flyer ? item.flyer.toString() : null
        if (flyer) {
          _data.push(flyer)
          exportableTemp.push(flyer)
        } else {
          _data.push("YES")
          exportableTemp.push("YES")
        }

        if (item.is_trade_letter === "1") {
          _data.push(
            <button onClick={() => handleShowSignature(item.signature_image)}>
              View
            </button>
          )
          exportableTemp.push(item.signature_image)
        } else {
          let trade_letter = item.trade_letter
            ? item.trade_letter.toString()
            : ""
          _data.push(trade_letter)
          exportableTemp.push(trade_letter)
        }

        //   data.push(item.is_trade_letter  === "1"?  <button
        //   onClick={() =>
        //     handleShow(long1, lat1, address1, store_name, photo)
        //   }
        // >
        //   View
        // </button>:item.trade_letter.toString());
        //   exportableTemp.push(
        //     item.trade_letter ? item.trade_letter.toString() : ""
        //   );

        _data.push(
          item.selling_illicit_cigar
            ? item.selling_illicit_cigar.toString()
            : ""
        )
        exportableTemp.push(
          item.selling_illicit_cigar
            ? item.selling_illicit_cigar.toString()
            : ""
        )

        let length = item?.illicit_cigar?.length || 0
        let illicit_cigar_details = (
          <div>
            {item?.illicit_cigar?.map((item, index) => {
              return (
                <>
                  <div key={index}>
                    <p>
                      Brand:{item.brand_name ? item.brand_name.toString() : ""}{" "}
                    </p>
                    <p>
                      Pack Price:{" "}
                      {item.pack_price ? item.pack_price.toString() : ""}
                    </p>
                    <p>
                      Sold Per Week:
                      {item.sold_per_week
                        ? item.sold_per_week.toString()
                        : ""}{" "}
                    </p>
                    <p>
                      Price Per Stick:{" "}
                      {item.stick_price ? item.stick_price.toString() : ""}
                    </p>
                  </div>
                  {index !== length - 1 ? <hr /> : null}
                </>
              )
            })}
          </div>
        )

        _data.push(illicit_cigar_details)

        let illicit_cigar_details_exportable = ""

        item?.illicit_cigar?.forEach((item, index) => {
          illicit_cigar_details_exportable +=
            "Brand: " +
            (item.brand_name ? item.brand_name.toString() : "") +
            ", Pack Price: " +
            (item.pack_price ? item.pack_price.toString() : "") +
            ", Sold Per Week: " +
            (item.sold_per_week ? item.sold_per_week.toString() : "") +
            ", Price Per Stick: " +
            (item.stick_price ? item.stick_price.toString() : "")
          illicit_cigar_details_exportable += index !== length - 1 ? " | " : ""
        })

        exportableTemp.push(illicit_cigar_details_exportable)

        _data.push(item.qr_code ? item.qr_code.toString() : "")
        exportableTemp.push(item.qr_code ? item.qr_code.toString() : "")

        _data.push(item.encoded_by ? item.encoded_by.toString() : "")
        exportableTemp.push(item.encoded_by ? item.encoded_by.toString() : "")

        _data.push(item.contact_no ? item.contact_no.toString() : "")
        exportableTemp.push(item.contact_no ? item.contact_no.toString() : "")

        dataToDisplay.push(_data)
        exportableData.push(exportableTemp)
      })
      //transform map urls to short urls
      extractedMapUrls.forEach((url, index) => {
        const shortenedUrl = url
        console.log("url", url)
        setMapUrls((mapUrls) => [...mapUrls, shortenedUrl + " " + index])
      })

      setExportable({ items: exportableData, headers: headers })
      setData(dataToDisplay)
    } else {
      let responseMessage = response?.data?.messages?.error
      setMessage({
        message: responseMessage ?? "Something went wrong.",
        type: "danger",
      })
      setShowToast(true)
    }
  }

  useEffect(() => {
    handleSearch()
  }, [])

  useEffect(() => {
    if (mapUrls.length === data.length && mapUrls[0]?.includes(" ")) {
      // order the map urls by index
      let orderedMapUrls = mapUrls.sort((a, b) => {
        return a.split(" ")[1] - b.split(" ")[1]
      })
      // remove the index from the map urls
      orderedMapUrls = orderedMapUrls.map((url) => url.split(" ")[0])
      setMapUrls(orderedMapUrls)
      console.log(orderedMapUrls)
    }
  }, [mapUrls, data.length])

  return (
    <div className="container-fluid">
      <div className="row text-center mt-4">
        <div className="col-md-12">
          <p className="h1 title">STORES</p>
        </div>
      </div>
      <div className="row mb-3">
        <div className="mt-3 col-12 col-sm-5">
          <InputGroup className="mb-sm-3">
            <Form.Control
              placeholder="Search"
              aria-label="Username"
              value={searchData.encodedBy}
              onChange={(e) =>
                setSearchData({ ...searchData, encodedBy: e.target.value })
              }
            />
          </InputGroup>
        </div>
        <div className="mt-3 col-12 col-sm-2">
          <DatePicker
            selected={searchData.dateFrom}
            onChange={(date) =>
              setSearchData({ ...searchData, dateFrom: date })
            }
            className="form-control"
          />
        </div>

        <div className="mt-3 col-12 col-sm-2">
          <DatePicker
            selected={searchData.dateTo}
            onChange={(date) => setSearchData({ ...searchData, dateTo: date })}
            className="form-control"
          />
        </div>

        <div className="mt-3 col-12 col-sm-3">
          <Button
            variant="primary"
            className="w-100 m-0"
            onClick={handleSearch}
          >
            Search
          </Button>
        </div>
      </div>
      <div className="row justify-content-center">
        <CustomTable
          items={data}
          mapUrls={mapUrls}
          setItems={setData}
          headers={headers}
          itemsPerPage={8}
          title="Stores"
          exportable={exportable}
          photoIndex={9}
          beginningIndex={0}
          endIndex={8}
        />
      </div>
      <CustomToast
        type={details.type}
        message={details.message}
        title="Store"
        show={showToast}
        setShow={setShowToast}
      />
      <Modal
        show={show}
        onHide={() => {
          setShow(false)
        }}
        centered
        className="p-0"
        style={{ zIndex: backdrop ? 99999 : 0 }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Store Location</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxWidth: "100%", maxHeight: "100%" }}>
          <CustomMap mapData={mapData} setBackdrop={setBackdrop} />
        </Modal.Body>
      </Modal>
      {/* show signature */}
      <Modal
        show={showSignature}
        onHide={() => {
          setShowSignature(false)
        }}
        centered
        className="p-0"
        style={{ zIndex: backdrop ? 99999 : 0 }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Store Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col style={{ display: "flex", justifyContent: "center" }}>
              <img src={signatureURL} />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default Login
